














import { computed, defineComponent } from "@vue/composition-api";
import { UserPublicData, UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "AvatarsGroup",
  components: { BaseAvatar },
  props: {
    users: { type: Array as () => UserPublicData[] | UserWithAvatar[], required: true },
    maxUsers: { type: Number, default: 3 },
    size: { type: [Number, String], default: 112 },
    reverse: { type: Boolean, default: false },
    // Visible part of each avatar (0-1): 0 = fully stacked, 1 = side-by-side
    visibleFraction: { type: Number, default: 0.5 },
  },
  setup(props) {
    const usersForDisplay = computed(() => {
      const sliced = props.users.slice(0, props.maxUsers);
      return props.reverse ? sliced.reverse() : sliced;
    });

    const sizeValue = computed(() => (typeof props.size === "string" ? parseFloat(props.size) : props.size));

    const cssVars = computed(() => {
      const size = sizeValue.value;
      const maxUsers = Math.min(props.maxUsers, props.users.length);
      const visibleFraction = props.visibleFraction;

      const paddingRight = (1 + visibleFraction) * size + visibleFraction * size * (maxUsers - 1);
      const marginRight = -(1 + visibleFraction) * size;

      return {
        "--padding-right": `${paddingRight}px`,
        "--margin-right": `${marginRight}px`,
      };
    });

    return {
      usersForDisplay,
      cssVars,
    };
  },
});
